export default __webpack_public_path__ + "static/last_year_5-44a5f20857dcedc273139975a78c2cf8.webp";